import { useState } from "react";
import { api } from "../lib/api.js";
import { navigate } from "../lib/router.js";
import { Field } from "../components/Field.js";
import { Button } from "../components/Button.js";

export function SignInScreen() {
  const [email, setEmail] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await api.requestMagicLink(email, inviteCode.trim() || undefined);
      navigate("/check-email", { query: { email } });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Try again.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-dvh flex items-center justify-center shell-surface px-[var(--spacing-gutter)] py-8">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <span className="trail-blaze-solid" style={{ width: 18, height: 30, borderRadius: 3 }} />
          <h1 className="font-display text-[28px] text-granite-900 dark:text-granite-50">lingoLoco</h1>
        </div>
        <p className="font-text text-granite-600 dark:text-granite-300 mb-6 leading-relaxed">
          Practical French for the Tour du Mont Blanc, 2027.
        </p>
        <form onSubmit={onSubmit} className="flex flex-col gap-4" noValidate>
          <Field
            label="Email"
            type="email"
            inputMode="email"
            autoComplete="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Field
            label="Invite code (if you were invited)"
            hint="Leave blank to sign in to your household."
            value={inviteCode}
            onChange={(e) => setInviteCode(e.target.value)}
            autoComplete="off"
          />
          {error && <p className="font-text text-blaze text-[15px]" role="alert">{error}</p>}
          <Button type="submit" size="lg" disabled={busy}>
            {busy ? "Sending…" : "Send sign-in link"}
          </Button>
        </form>
      </div>
    </div>
  );
}
